import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function NavBar({ onAgregar }) {
  const [categorias, setCategorias] = useState([]);
  const API_URL = `${process.env.REACT_APP_API_URL}/api`;

  useEffect(() => {
    axios.get(`${API_URL}/categorias/all`)
      .then(res => setCategorias(res.data))
      .catch(() => {});
  }, []);

  return (
    <nav className="navbar">
      <Link to="/"><button>PRODUCTOS DISPONIBLES</button></Link>
      {categorias.map(categoria => (
        <Link key={categoria.id} to={`/categoria/${categoria.id}`}>
          <button>{categoria.nombre.toUpperCase()}</button>
        </Link>
      ))}
    </nav>
  );
}

export default NavBar;
